import React from 'react'

export default function ModalWindowStyle(props) {
  return (
    <style jsx='true'>
    {`
      html {
        --form-border-radius: 2px;
      }

      .modal-window-shadow {
        display: flex;
        position: fixed;
        z-index: 1;
        left: 0;
        top: 0;
        height: 100%;
        width: 100%;
        overflow: auto;
        background-color: rgba(0, 0, 0, 0.5);
        justify-content: center;
        align-items: center;
      }

      .modal-window-ui {
        display: grid;
        grid-template-columns: 1fr;
        grid-template-rows: auto 1fr auto;
        grid-template-areas:
          "modal-form-header"
          "modal-form-contents"
          "modal-form-footer";
        box-shadow: 0 5px 8px 0 rgba(0, 0, 0, 0.2), 0 7px 20px 0 rgba(0, 0, 0, 0.2);
        animation-name: modalopen;
        animation-duration: 300ms;
        border-radius: var(--form-border-radius);
      }
      #mwui-${props.id} { width: ${props.width}%; }

      .modal-window-header, .modal-window-footer {
        display: flex;
        font-size: 1em;
        border-radius: var(--form-border-radius) var(--form-border-radius) 0 0;
        padding: 10px;
        background-color: darkgrey;
        color: whitesmoke;
        height: 20px;
      }

      .modal-window-content {
        background-color: white;
        padding: 10px;
        font-size: 1.5rem;
      }
      #mwc-${props.id} { height: ${props.height}vh; }

      @keyframes modalopen {
        from {opacity: 0}
        to {opacity: 1}
      }
    `}
    </style>
  )
}
